import Content from "../components/Content";
import Footer from "../components/Footer";
import Header from "../components/Header";


function Home(){
    return(<div>
        <Header/>
        <Content/>
        <Footer/>
    </div>)
}

export default Home;